import { FC, useMemo } from 'react';

import { Icon } from '@shared/components/icons';
import {
  releaseNoteChannelsOfRole,
  useReleaseNotes,
} from '@shared/releaseNotes/useReleaseNotes';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Link } from 'react-router-dom';

import { AdminMenuIconKey, adminMenuGroups } from '../components/adminMenuConfig';
import { useAdminTitleHook } from '../hooks/useAdminTitleHook';
import { useFuneralHomeDnNoneCountHook } from '../hooks/useFuneralHomeDnStatusHook';

//* 아이콘 원본 크기가 24~48px로 제각각이라 CSS로 통일한다.
//* FontAwesome 계열(크기 미지정·글리프가 뷰박스를 꽉 채움)은 한 단계 작게 맞춰야 비슷해 보임
const FULL_GLYPH_ICON_KEYS = new Set<AdminMenuIconKey>([
  'Phone',
  'LocationDotSolid',
  'Home',
  'Question',
]);
const iconSizeClass = (icon: AdminMenuIconKey) =>
  FULL_GLYPH_ICON_KEYS.has(icon) ? 'wh-5' : 'wh-6';

//* 관리자 홈: 사이드바를 열지 않고도 주요 기능에 바로 진입하는 런처 (모바일 우선)
const AdminHomePage: FC = () => {
  useAdminTitleHook('관리자 홈', undefined, undefined, true, undefined, false);

  const icons = Icon();
  const { roles } = useAuth();
  const releaseNoteChannels = useMemo(() => releaseNoteChannelsOfRole(roles), [roles]);
  const { hasUnread: hasUnreadReleaseNote } = useReleaseNotes(releaseNoteChannels);
  //* 꽃집(DN) 미연결 장례식장 수 — 있으면 장례식장 메뉴에 빨간 숫자 배지
  const dnNoneCount = useFuneralHomeDnNoneCountHook();

  return (
    <div className="space-y-4 p-4 pb-10">
      {adminMenuGroups.map((group) => (
        <div key={group.label}>
          <p className="px-1 pb-1 text-xs font-bold leading-5 theme-text-8">
            {group.label}
          </p>
          <div className="grid grid-cols-4 gap-y-4 py-4 shadow-smd theme-bg-1">
            {group.items.map((item) => {
              const ItemIcon = icons[item.icon];
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className="flex flex-col items-center gap-1.5"
                >
                  <div className="center-box wh-10 relative rounded-full theme-bg-18">
                    <ItemIcon className={iconSizeClass(item.icon)} />
                    {item.releaseNoteDot && hasUnreadReleaseNote && (
                      <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-red-500" />
                    )}
                    {item.dnNoneBadge && !!dnNoneCount && (
                      <span className="absolute -right-1.5 -top-1 min-w-[16px] rounded-full bg-red-500 px-1 text-center text-[10px] font-bold leading-4 text-white">
                        {dnNoneCount}
                      </span>
                    )}
                  </div>
                  <p className="text-center text-12 leading-4">{item.label}</p>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminHomePage;
